export default __webpack_public_path__ + "static/media/google-store-img.a95dc336.png";